// 2022 Topps Star Wars Masterwork — GENERATED by pipeline-publish (2026-05-24)
// =============================================================================
// Auto-generated from the set draft. Colors, sub-set types, ordering, and the
// SET_REGISTRY entry below are filled in. REVIEW before committing:
//   - Any placeholder color marker (a parallel name not in the standard color
//     map; the commit guard blocks until every one is resolved).
//   - Rule-7 base serial slots on numbered auto/sketch sub-sets (see in-array
//     notes; the warnings list above flags only sub-sets actually missing one).
//   - Sanity-check the auto-classified sub-set `type` and ordering.
//   - Any placeholder in the SET_REGISTRY entry below (only present if no DB
//     sets row exists for this slug, or fields are blank).
//   - A source/specimen pass on parallel names + print runs.
//   - node --check src/sets/2022-masterwork.js if committing by hand, then commit + push.
//
// SET_REGISTRY entry (paste into src/setRegistry.js):
//   {
//     id: "2022-masterwork",
//     name: "2022 Topps Star Wars Masterwork",
//     shortName: "Masterwork 2022",
//     year: 2022,
//     brand: "Topps",
//     category: 'Star Wars',
//     releaseDate: "2022",
//     totalCards: 605,
//     description: "Topps 2022 Topps Star Wars Masterwork trading card set.",
//     color: "#c9a227",
//     accentColor: "#f0c040",
//     dataFile: "2022-masterwork",
//   },
// =============================================================================

export const SETS = [
  {
    id: "base-cards",
    type: "base",
    title: "BASE CARDS",
    parallels: [
        { id: "blue", name: "Blue", print_run: null, color: "#2979ff" },
        { id: "green", name: "Green", print_run: 99, color: "#00e676" },
        { id: "purple", name: "Purple", print_run: 50, color: "#b060ff" },
        { id: "red", name: "Red", print_run: 25, color: "#ff1744" },
        { id: "orange", name: "Orange", print_run: 10, color: "#ff9100" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "1", name: "Bo-Katan Kryze" },
        { n: "2", name: "Valin Hess" },
        { n: "3", name: "Migs Mayfeld" },
        { n: "4", name: "Greef Karga" },
        { n: "5", name: "Moff Gideon" },
        { n: "6", name: "Kuiil" },
        { n: "7", name: "IG-11" },
        { n: "8", name: "Zero" },
        { n: "9", name: "Koska Reeves" },
        { n: "10", name: "Carson Teva" },
        { n: "11", name: "Magistrate Morgan Elsbeth" },
        { n: "12", name: "R2-D2" },
        { n: "13", name: "C-3PO" },
        { n: "14", name: "Babu Frik" },
        { n: "15", name: "Zorii Bliss" },
        { n: "16", name: "Rey" },
        { n: "17", name: "Poe Dameron" },
        { n: "18", name: "Kylo Ren" },
        { n: "19", name: "Finn" },
        { n: "20", name: "Lando Calrissian" },
        { n: "21", name: "Chewbacca" },
        { n: "22", name: "Padmé Amidala" },
        { n: "23", name: "Kaydel Ko Connix" },
        { n: "24", name: "Jannah" },
        { n: "25", name: "BB-8" },
        { n: "26", name: "Qui-Gon Jinn" },
        { n: "27", name: "Luke Skywalker" },
        { n: "28", name: "General Leia Organa" },
        { n: "29", name: "Han Solo" },
        { n: "30", name: "Quinlan Vos" },
        { n: "31", name: "Asajj Ventress" },
        { n: "32", name: "Jar Jar Binks" },
        { n: "33", name: "Ahsoka Tano" },
        { n: "34", name: "Grogu" },
        { n: "35", name: "The Mandalorian" },
        { n: "36", name: "Boba Fett" },
        { n: "37", name: "Fennec Shand" },
        { n: "38", name: "Garsa Fwip" },
        { n: "39", name: "Twi'lek Majordomo" },
        { n: "40", name: "Krrsantan" },
        { n: "41", name: "The Twins" },
        { n: "42", name: "Drash" },
        { n: "43", name: "Skad" },
        { n: "44", name: "Tatooine Sand Ape" },
        { n: "45", name: "Cad Bane" },
        { n: "46", name: "Cobb Vanth" },
        { n: "47", name: "The Armorer" },
        { n: "48", name: "Axe Woves" },
        { n: "49", name: "Peli Motto" },
        { n: "50", name: "Omega" },
        { n: "51", name: "Hunter" },
        { n: "52", name: "Tech" },
        { n: "53", name: "Wrecker" },
        { n: "54", name: "Cid" },
        { n: "55", name: "Crosshair" },
        { n: "56", name: "Echo" },
        { n: "57", name: "Captain Rex" },
        { n: "58", name: "Darth Sidious" },
        { n: "59", name: "General Grievous" },
        { n: "60", name: "Mace Windu" },
        { n: "61", name: "Obi-Wan Kenobi" },
        { n: "62", name: "The Grand Inquisitor" },
        { n: "63", name: "Fifth Brother" },
        { n: "64", name: "Owen Lars" },
        { n: "65", name: "Beru Lars" },
        { n: "66", name: "Third Sister" },
        { n: "67", name: "Darth Vader" },
        { n: "68", name: "Jango Fett" },
        { n: "69", name: "Count Dooku" },
        { n: "70", name: "Cassian Andor" },
        { n: "71", name: "Mon Mothma" },
        { n: "72", name: "Kazuda Xiono" },
        { n: "73", name: "Tam Ryvora" },
        { n: "74", name: "Major Vonreg" },
        { n: "75", name: "Jarek Yeager" },
        { n: "76", name: "Commander Pyre" },
        { n: "77", name: "Agent Tierny" },
        { n: "78", name: "Torra Doza" },
        { n: "79", name: "Kanan Jarrus" },
        { n: "80", name: "Hera Syndulla" },
        { n: "81", name: "Ezra Bridger" },
        { n: "82", name: "Zeb Orrelios" },
        { n: "83", name: "Sabine Wren" },
        { n: "84", name: "Cal Kestis" },
        { n: "85", name: "BD-1" },
        { n: "86", name: "Second Sister" },
        { n: "87", name: "Ninth Sister" },
        { n: "88", name: "Cere Junda" },
        { n: "89", name: "Merrin" },
        { n: "90", name: "L3-37" },
        { n: "91", name: "Maul" },
        { n: "92", name: "Qi'ra" },
        { n: "93", name: "Bail Organa" },
        { n: "94", name: "K-2SO" },
        { n: "95", name: "Chirrut Îmwe" },
        { n: "96", name: "Baze Malbus" },
        { n: "97", name: "Bodhi Rook" },
        { n: "98", name: "Jyn Erso" },
        { n: "99", name: "Galen Erso" },
        { n: "100", name: "Director Krennic" },
    ],
  },
  {
    id: "bounty-hunting-a-complicated-profession",
    type: "insert",
    title: "BOUNTY HUNTING A COMPLICATED PROFESSION",
    parallels: [
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 299, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "metal", name: "Metal", print_run: 5, color: "#c0c0c8" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "BH-1", name: "Boba Fett (Star Wars: The Empire Strikes Back)" },
        { n: "BH-2", name: "Boba Fett (The Book of Boba Fett)" },
        { n: "BH-3", name: "The Mandalorian (The Mandalorian)" },
        { n: "BH-4", name: "IG-11 (The Mandalorian)" },
        { n: "BH-5", name: "Krrsantan (The Book of Boba Fett)" },
        { n: "BH-6", name: "Cad Bane (The Book of Boba Fett)" },
        { n: "BH-7", name: "Fennec Shand (The Mandalorian)" },
        { n: "BH-8", name: "IG-88 (Star Wars: The Empire Strikes Back)" },
        { n: "BH-9", name: "Dengar (Star Wars: The Empire Strikes Back)" },
        { n: "BH-10", name: "Bossk (Star Wars: The Empire Strikes Back)" },
        { n: "BH-11", name: "Jango Fett (Star Wars: Attack of the Clones)" },
        { n: "BH-12", name: "Greedo (Star Wars: A New Hope)" },
        { n: "BH-13", name: "Aurra Sing (Star Wars: The Phantom Menace)" },
        { n: "BH-14", name: "Asajj Ventress (Star Wars: The Clone Wars)" },
        { n: "BH-15", name: "Toro Calican (The Mandalorian)" },
    ],
  },
  {
    id: "bounty-hunting-a-complicated-profession-gold-metal-variation",
    type: "insert",
    title: "BOUNTY HUNTING A COMPLICATED PROFESSION GOLD METAL VARIATION",
    parallels: [],
    cards: [
        { n: "BHG-1", name: "Boba Fett (Star Wars: The Empire Strikes Back)" },
        { n: "BHG-2", name: "Boba Fett (The Book of Boba Fett)" },
        { n: "BHG-3", name: "The Mandalorian (The Mandalorian)" },
        { n: "BHG-4", name: "IG-11 (The Mandalorian)" },
        { n: "BHG-5", name: "Krrsantan (The Book of Boba Fett)" },
        { n: "BHG-6", name: "Cad Bane (The Book of Boba Fett)" },
        { n: "BHG-7", name: "Fennec Shand (The Mandalorian)" },
        { n: "BHG-8", name: "IG-88 (Star Wars: The Empire Strikes Back)" },
        { n: "BHG-9", name: "Dengar (Star Wars: The Empire Strikes Back)" },
        { n: "BHG-10", name: "Bossk (Star Wars: The Empire Strikes Back)" },
        { n: "BHG-11", name: "Jango Fett (Star Wars: Attack of the Clones)" },
        { n: "BHG-12", name: "Greedo (Star Wars: A New Hope)" },
        { n: "BHG-13", name: "Aurra Sing (Star Wars: The Phantom Menace)" },
        { n: "BHG-14", name: "Asajj Ventress (Star Wars: The Clone Wars)" },
        { n: "BHG-15", name: "Toro Calican (The Mandalorian)" },
    ],
  },
  {
    id: "costume-relic-cards",
    type: "insert",
    title: "COSTUME RELIC CARDS",
    parallels: [
        { id: "green", name: "Green", print_run: 99, color: "#00e676" },
        { id: "purple", name: "Purple", print_run: 50, color: "#b060ff" },
        { id: "red", name: "Red", print_run: 25, color: "#ff1744" },
        { id: "orange", name: "Orange", print_run: 10, color: "#ff9100" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "CR-AT", name: "Ahsoka Tano" },
        { n: "CR-DV", name: "Dryden Vos" },
        { n: "CR-FS", name: "Fennec Shand" },
        { n: "CR-JE", name: "Jyn Erso" },
        { n: "CR-LU", name: "Luke Skywalker" },
        { n: "CR-ME", name: "Magistrate Morgan Elsbeth" },
        { n: "CR-PD", name: "Poe Dameron" },
        { n: "CR-R", name: "Rey" },
        { n: "CR-RE", name: "Rey" },
        { n: "CR-TA", name: "The Armorer" },
        { n: "CR-TM", name: "The Mandalorian" },
    ],
  },
  {
    id: "hello-there",
    type: "insert",
    title: "HELLO THERE: THE QUOTES OF OBI-WAN KENOBI",
    parallels: [
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 299, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "metal", name: "Metal", print_run: 5, color: "#c0c0c8" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "OB1-1", name: "\"Use the Force, Luke.\" (Star Wars: A New Hope)" },
        { n: "OB1-2", name: "\"Only a Sith deals in absolutes.\" (Star Wars: Revenge of the Sith)" },
        { n: "OB1-3", name: "\"Hello, there.\" (Star Wars: Revenge of the Sith)" },
        { n: "OB1-4", name: "\"I have the high ground.\" (Star Wars: Revenge of the Sith)" },
        { n: "OB1-5", name: "\"Luke, you're going to find that many of the truths we cling to depend greatly on our own point of view.\" (Star Wars: Return of the Jedi)" },
        { n: "OB1-6", name: "\"Who is more foolish? The fool or the fool who follows him?\" (Star Wars: A New Hope)" },
        { n: "OB1-7", name: "\"Be mindful of your thoughts, Anakin, they betray you.\" (Star Wars: Attack of the Clones)" },
        { n: "OB1-8", name: "\"If you strike me down, I shall become more powerful than you can possibly imagine.\" (Star Wars: A New Hope)" },
        { n: "OB1-9", name: "\"So uncivilized.\" (Star Wars: Revenge of the Sith)" },
        { n: "OB1-10", name: "\"If you define yourself by the power to take life, the desire to dominate, to possess...then you have nothing.\" (Star Wars Rebels)" },
    ],
  },
  {
    id: "hello-there-gold-metal-variation",
    type: "insert",
    title: "HELLO THERE: THE QUOTES OF OBI-WAN KENOBI GOLD METAL VARIATION",
    parallels: [],
    cards: [
        { n: "OB1G-1", name: "\"Use the Force, Luke.\" (Star Wars: A New Hope)" },
        { n: "OB1G-2", name: "\"Only a Sith deals in absolutes.\" (Star Wars: Revenge of the Sith)" },
        { n: "OB1G-3", name: "\"Hello, there.\" (Star Wars: Revenge of the Sith)" },
        { n: "OB1G-4", name: "\"I have the high ground.\" (Star Wars: Revenge of the Sith)" },
        { n: "OB1G-5", name: "\"Luke, you're going to find that many of the truths we cling to depend greatly on our own point of view.\" (Star Wars: Return of the Jedi)" },
        { n: "OB1G-6", name: "\"Who is more foolish? The fool or the fool who follows him?\" (Star Wars: A New Hope)" },
        { n: "OB1G-7", name: "\"Be mindful of your thoughts, Anakin, they betray you.\" (Star Wars: Attack of the Clones)" },
        { n: "OB1G-8", name: "\"If you strike me down, I shall become more powerful than you can possibly imagine.\" (Star Wars: A New Hope)" },
        { n: "OB1G-9", name: "\"So uncivilized.\" (Star Wars: Revenge of the Sith)" },
        { n: "OB1G-10", name: "\"If you define yourself by the power to take life, the desire to dominate, to possess...then you have nothing.\" (Star Wars Rebels)" },
    ],
  },
  {
    id: "on-screen-prop-relics",
    type: "insert",
    title: "ON SCREEN PROP RELICS",
    parallels: [
        { id: "green", name: "Green", print_run: 99, color: "#00e676" },
        { id: "purple", name: "Purple", print_run: 50, color: "#b060ff" },
        { id: "red", name: "Red", print_run: 25, color: "#ff1744" },
        { id: "orange", name: "Orange", print_run: 10, color: "#ff9100" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "OSPR-BM", name: "Baze Malbus" },
        { n: "OSPR-BO", name: "Bail Organa" },
        { n: "OSPR-BR", name: "Bodhi Rook" },
        { n: "OSPR-CA", name: "Cassian Andor" },
        { n: "OSPR-CI", name: "Chirrut Îmwe" },
        { n: "OSPR-GM", name: "General Merrick" },
        { n: "OSPR-JD", name: "Jan Dodonna" },
        { n: "OSPR-JE", name: "Jyn Erso" },
        { n: "OSPR-K2", name: "K-2SO" },
        { n: "OSPR-MM", name: "Mon Mothma" },
    ],
  },
  {
    id: "original-trilogy-poster-cards",
    type: "insert",
    title: "ORIGINAL TRILOGY POSTER CARDS",
    parallels: [
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 299, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "metal", name: "Metal", print_run: 5, color: "#c0c0c8" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "OT-1", name: "Obi-Wan Kenobi (Star Wars: A New Hope)" },
        { n: "OT-2", name: "Lando Calrissian (Star Wars: The Empire Strikes Back)" },
        { n: "OT-3", name: "Tusken Raider (Star Wars: A New Hope)" },
        { n: "OT-4", name: "Jabba The Hutt (Star Wars: Return of the Jedi)" },
        { n: "OT-5", name: "Imperial Royal Guard (Star Wars: Return of the Jedi)" },
        { n: "OT-6", name: "Grand Moff Tarkin (Star Wars: A New Hope)" },
        { n: "OT-7", name: "Jawas (Star Wars: A New Hope)" },
        { n: "OT-8", name: "Wicket W. Warrick (Star Wars: Return of the Jedi)" },
        { n: "OT-9", name: "Princess Leia Organa (Star Wars: A New Hope)" },
        { n: "OT-10", name: "Princess Leia Organa (Star Wars: A New Hope)" },
        { n: "OT-11", name: "Princess Leia Organa (Star Wars: A New Hope)" },
        { n: "OT-12", name: "C-3PO & R2-D2 (Star Wars: A New Hope)" },
        { n: "OT-13", name: "Chewbacca (Star Wars: The Empire Strikes Back)" },
        { n: "OT-14", name: "Yoda (Star Wars: The Empire Strikes Back)" },
        { n: "OT-15", name: "Chewbacca (Star Wars: The Empire Strikes Back)" },
        { n: "OT-16", name: "Stormtrooper (Star Wars: The Empire Strikes Back)" },
        { n: "OT-17", name: "Stormtrooper (Star Wars: Return of the Jedi)" },
        { n: "OT-18", name: "Emperor Palpatine (Star Wars: Return of the Jedi)" },
        { n: "OT-19", name: "Boba Fett (Star Wars: The Empire Strikes Back)" },
        { n: "OT-20", name: "Boba Fett (Star Wars: The Empire Strikes Back)" },
        { n: "OT-21", name: "Han Solo (Star Wars: A New Hope)" },
        { n: "OT-22", name: "Luke Skywalker (Star Wars: A New Hope)" },
        { n: "OT-23", name: "Luke Skywalker (Star Wars: The Empire Strikes Back)" },
        { n: "OT-24", name: "Darth Vader (Star Wars: A New Hope)" },
        { n: "OT-25", name: "Darth Vader (Star Wars: The Empire Strikes Back)" },
    ],
  },
  {
    id: "original-trilogy-poster-cards-gold-metal-variation",
    type: "insert",
    title: "ORIGINAL TRILOGY POSTER CARDS GOLD METAL VARIATION",
    parallels: [],
    cards: [
        { n: "OTG-1", name: "Obi-Wan Kenobi (Star Wars: A New Hope)" },
        { n: "OTG-2", name: "Lando Calrissian (Star Wars: The Empire Strikes Back)" },
        { n: "OTG-3", name: "Tusken Raider (Star Wars: A New Hope)" },
        { n: "OTG-4", name: "Jabba The Hutt (Star Wars: Return of the Jedi)" },
        { n: "OTG-5", name: "Imperial Royal Guard (Star Wars: Return of the Jedi)" },
        { n: "OTG-6", name: "Grand Moff Tarkin (Star Wars: A New Hope)" },
        { n: "OTG-7", name: "Jawas (Star Wars: A New Hope)" },
        { n: "OTG-8", name: "Wicket W. Warrick (Star Wars: Return of the Jedi)" },
        { n: "OTG-9", name: "Princess Leia Organa (Star Wars: A New Hope)" },
        { n: "OTG-10", name: "Princess Leia Organa (Star Wars: A New Hope)" },
        { n: "OTG-11", name: "Princess Leia Organa (Star Wars: A New Hope)" },
        { n: "OTG-12", name: "C-3PO & R2-D2 (Star Wars: A New Hope)" },
        { n: "OTG-13", name: "Chewbacca (Star Wars: The Empire Strikes Back)" },
        { n: "OTG-14", name: "Yoda (Star Wars: The Empire Strikes Back)" },
        { n: "OTG-15", name: "Chewbacca (Star Wars: The Empire Strikes Back)" },
        { n: "OTG-16", name: "Stormtrooper (Star Wars: The Empire Strikes Back)" },
        { n: "OTG-17", name: "Stormtrooper (Star Wars: Return of the Jedi)" },
        { n: "OTG-18", name: "Emperor Palpatine (Star Wars: Return of the Jedi)" },
        { n: "OTG-19", name: "Boba Fett (Star Wars: The Empire Strikes Back)" },
        { n: "OTG-20", name: "Boba Fett (Star Wars: The Empire Strikes Back)" },
        { n: "OTG-21", name: "Han Solo (Star Wars: A New Hope)" },
        { n: "OTG-22", name: "Luke Skywalker (Star Wars: A New Hope)" },
        { n: "OTG-23", name: "Luke Skywalker (Star Wars: The Empire Strikes Back)" },
        { n: "OTG-24", name: "Darth Vader (Star Wars: A New Hope)" },
        { n: "OTG-25", name: "Darth Vader (Star Wars: The Empire Strikes Back)" },
    ],
  },
  {
    id: "stamp-cards",
    type: "insert",
    title: "STAMP CARDS",
    parallels: [
        { id: "green", name: "Green", print_run: 99, color: "#00e676" },
        { id: "purple", name: "Purple", print_run: 50, color: "#b060ff" },
        { id: "red", name: "Red", print_run: 25, color: "#ff1744" },
        { id: "orange", name: "Orange", print_run: 10, color: "#ff9100" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "SC-DM", name: "Darth Maul" },
        { n: "SC-DV", name: "Darth Vader" },
        { n: "SC-HS", name: "Han Solo" },
        { n: "SC-KR", name: "Kylo Ren" },
        { n: "SC-LO", name: "General Leia Organa" },
        { n: "SC-LS", name: "Luke Skywalker" },
        { n: "SC-MD", name: "The Mandalorian" },
        { n: "SC-R", name: "Reva" },
        { n: "SC-RS", name: "Rey" },
    ],
  },
  {
    id: "manufactured-tools-and-technology-medallion-cards",
    type: "insert",
    title: "MANUFACTURED TOOLS AND TECHNOLOGY MEDALLION CARDS",
    parallels: [
        { id: "green", name: "Green", print_run: 99, color: "#00e676" },
        { id: "purple", name: "Purple", print_run: 50, color: "#b060ff" },
        { id: "red", name: "Red", print_run: 25, color: "#ff1744" },
        { id: "orange", name: "Orange", print_run: 10, color: "#ff9100" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "TTM-K", name: "Krrsantan" },
        { n: "TTM-KR", name: "Kylo Ren" },
        { n: "TTM-MG", name: "Moff Gideon" },
        { n: "TTM-P", name: "Palpatine" },
        { n: "TTM-Q", name: "Qi'ra" },
        { n: "TTM-R", name: "Rey" },
        { n: "TTM-TC", name: "The Client" },
        { n: "TTM-TM", name: "The Mandalorian" },
        { n: "TTM-TM2", name: "The Mandalorian" },
    ],
  },
  {
    id: "costume-relic-cards-autograph-parallel",
    type: "auto",
    title: "COSTUME RELIC CARDS AUTOGRAPH PARALLEL",
    parallels: [
        // Serial-numbered /3 (Cardboard Connection × Beckett agree).
        { id: "one-of-one", name: "", print_run: 3, color: "#c8d8f0" },
      ],
    cards: [
        { n: "CRA-AD", name: "Adam Driver as Kylo Ren" },
        { n: "CRA-AD2", name: "Adam Driver as Kylo Ren" },
        { n: "CRA-DR", name: "Daisy Ridley as Rey" },
        { n: "CRA-DR2", name: "Daisy Ridley as Rey" },
        { n: "CRA-FJ", name: "Felicity Jones as Jyn Erso" },
        { n: "CRA-MW", name: "Ming-Na Wen as Fennec Shand" },
        { n: "CRA-RD", name: "Rosario Dawson as Ahsoka Tano" },
    ],
  },
  {
    id: "on-card-autographs",
    type: "auto",
    title: "ON CARD AUTOGRAPHS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "blue-foil", name: "Blue Foil", print_run: 99, color: "#4d9fff" },
        { id: "rainbow-foil", name: "Rainbow Foil", print_run: 50, color: "#c8a4ff" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "silver-frame", name: "Silver Frame", print_run: 5, color: "#bdbdbd" },
        { id: "gold-frame", name: "Gold Frame", print_run: 1, color: "#f0c040" },
        { id: "printing-plates", name: "Printing Plates", print_run: 1, color: "#b0b0b8" },
      ],
    cards: [
        { n: "MWA-ABA", name: "Andrea Bartlow as Twi'lek Server" },
        { n: "MWA-ABE", name: "Ahmed Best as Jar Jar Binks" },
        { n: "MWA-AG", name: "Allan Graf as Bartender" },
        { n: "MWA-AH", name: "Alfred Hsing as Pyke Traveler" },
        { n: "MWA-AK", name: "Andrew Kishino as Saw Gerrera" },
        { n: "MWA-AW", name: "Alexander Wraith as Imperial Freighter Pilot" },
        { n: "MWA-BH", name: "Brian Herring as BB-8" },
        { n: "MWA-BP", name: "Bonnie Piesse as Beru Lars" },
        { n: "MWA-CB", name: "Chris Bartlett as Teacher Droid" },
        { n: "MWA-CG", name: "Clare Grant as Latts Razzi" },
        { n: "MWA-CJ", name: "Carey Jones as Krrsantan" },
        { n: "MWA-DA", name: "David Acord as FN-2199" },
        { n: "MWA-DB1", name: "Dee Bradley Baker as Captain Rex" },
        { n: "MWA-DB2", name: "Dee Bradley Baker as Hunter" },
        { n: "MWA-DB3", name: "Dee Bradley Baker as Wrecker" },
        { n: "MWA-DB4", name: "Dee Bradley Baker as Echo" },
        { n: "MWA-DB5", name: "Dee Bradley Baker as Crosshair" },
        { n: "MWA-DB6", name: "Dee Bradley Baker as Tech" },
        { n: "MWA-DK", name: "Dorian Kingi as Cad Bane" },
        { n: "MWA-DLI", name: "Diana Lee Inosanto as Magistrate Morgan Elsbeth" },
        { n: "MWA-DR", name: "Daisy Ridley as Rey" },
        { n: "MWA-EC", name: "Emilia Clarke as Qi'ra" },
        { n: "MWA-ES", name: "Emily Swallow as The Armorer" },
        { n: "MWA-GE", name: "Giancarlo Esposito as Moff Gideon" },
        { n: "MWA-JCU", name: "Jim Cummings as Hondo Ohnaka" },
        { n: "MWA-JD", name: "Julie Dolan as Princess Leia Organa" },
        { n: "MWA-JK", name: "Jaime King as Aurra Sing" },
        { n: "MWA-JL", name: "John Leguizamo as Gor Koresh" },
        { n: "MWA-JS", name: "Jason Spisak as Lux Bonteri" },
        { n: "MWA-KO", name: "Katy O'Brian as Imperial Comms Officer" },
        { n: "MWA-KS", name: "Katee Sackhoff as Bo-Katan Kryze" },
        { n: "MWA-KSH", name: "Kiran Shah as Nambi Ghima" },
        { n: "MWA-LS", name: "Leilani Shiu as Jawa" },
        { n: "MWA-MBJ", name: "Mark Boone Junior as Ranzar Malk" },
        { n: "MWA-MBO", name: "Michonne Bourriague as Aurra Sing" },
        { n: "MWA-MH", name: "Mark Hamill as Luke Skywalker" },
        { n: "MWA-MI", name: "Moses Ingram as Reva" },
        { n: "MWA-MNW", name: "Ming-Na Wen as Fennec Shand" },
        { n: "MWA-MPM", name: "Murphy Patrick Martin as Drummer" },
        { n: "MWA-MR", name: "Misty Rosas as Frog Lady" },
        { n: "MWA-MV", name: "Mercedes Varnado as Koska Reeves" },
        { n: "MWA-MW", name: "Matthew Wood as General Grievous" },
        { n: "MWA-NF", name: "Nika Futterman as Asajj Ventress" },
        { n: "MWA-OA", name: "Omid Abtahi as Dr. Pershing" },
        { n: "MWA-OD", name: "Olivia d'ABO as Luminara Unduli" },
        { n: "MWA-PA", name: "Philip Alexander as Fifth Brother" },
        { n: "MWA-PAR", name: "Philip Anthony-Rodriguez as Imperial Security Officer" },
        { n: "MWA-PD", name: "Paul Darnell as C'ai Threnalli" },
        { n: "MWA-PK", name: "Paul Kasey as Night Wind Assassin" },
        { n: "MWA-PSL", name: "Paul Sun-Hyung Lee as Captain Carson Teva" },
        { n: "MWA-RB", name: "Richard Brake as Valin Hess" },
        { n: "MWA-RD", name: "Rosario Dawson as Ahsoka Tano" },
        { n: "MWA-RO", name: "Rena Owen as Taun We" },
        { n: "MWA-SB", name: "Skyler Bible as Fixer" },
        { n: "MWA-SK", name: "Simon Kassianides as Axe Woves" },
        { n: "MWA-SS", name: "Stephen Stanton as Admiral Tarkin" },
        { n: "MWA-SW", name: "Sam Witwer as Maul" },
        { n: "MWA-TF", name: "Tait Fletcher as Alpha Trawler" },
        { n: "MWA-TG", name: "Taylor Gray as Ezra Bridger" },
        { n: "MWA-TM", name: "Temuera Morrison as Boba Fett" },
        { n: "MWA-TO", name: "Timothy Olyphant as Cobb Vanth" },
        { n: "MWA-TR", name: "Tim Rose as Admiral Ackbar" },
        { n: "MWA-TS", name: "Tiya Sircar as Sabine Wren" },
    ],
  },
  {
    id: "dual-autograph-cards",
    type: "auto",
    title: "DUAL AUTOGRAPH CARDS",
    parallels: [
        // Base card is serial-numbered /50 (Cardboard Connection × Beckett agree).
        { id: "base", name: "", print_run: 50, color: "#c8d8f0" },
        { id: "canvas", name: "Canvas", print_run: 25, color: "#d4b88e" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "MWD-BQ", name: "Ralph Brown / Hugh Quarshie as Ric Olié / Captain Panaka" },
        { n: "MWD-CE", name: "Alden Ehrenreich / Emilia Clarke as Han Solo / Qi'ra" },
        { n: "MWD-GB", name: "Steve Blum / Taylor Gray as Zeb Orrelios / Ezra Bridger" },
        { n: "MWD-GC", name: "Taylor Gray / Jim Cummings as Ezra Bridger / Hondo Ohnaka" },
        { n: "MWD-HM", name: "Guy Henry / Ben Mendelsohn as Governor Tarkin / Director Krennic" },
        { n: "MWD-JW", name: "Forest Whitaker / Felicity Jones as Saw Gerrera / Jyn Erso" },
        { n: "MWD-MC", name: "Ewan McGregor / Hayden Christensen as Obi-Wan Kenobi / Darth Vader" },
        { n: "MWD-PM", name: "Natalie Portman / Ian McDiarmid as Padmé Amidala / Chancellor Palpatine" },
        { n: "MWD-TL", name: "Kelly Marie Tran / Billie Lourd as Rose Tico / Kaydel Ko Connix" },
        { n: "MWD-WJ", name: "Ming-Na Wen / Carey Jones as Fennec Shand / Krrsantan" },
    ],
  },
  {
    id: "quad-autograph-book-cards",
    type: "auto",
    title: "QUAD AUTOGRAPH BOOK CARDS",
    parallels: [
        // Base card is serial-numbered /2 — two copies of each book
        // (Cardboard Connection × Beckett agree).
        { id: "one-of-one", name: "", print_run: 2, color: "#c8d8f0" },
      ],
    cards: [
        { n: "MWQ-CMEP", name: "Ewan McGregor / Hayden Christensen / Bonnie Piesse / Joel Edgerton as Obi-Wan Kenobi / Anakin Skywalker / Beru Lars / Owen Lars" },
        { n: "MWQ-JMMK", name: "Valene Kane / Mads Mikkelsen / Ben Mendelsohn / Felicity Jones as Lyra Erso / Galen Erso / Director Krennic / Jyn Erso" },
        { n: "MWQ-MWJP", name: "Carey Jones / Ming-Na Wen / Temuera Morrison / David Pasquesi as Krrsantan / Fennec Shand / Boba Fett / Twi'lek Majordomo" },
        { n: "MWQ-PDWE", name: "Taika Waititi / Giancarlo Esposito / Rosario Dawson / Pedro Pascal as IG-11 / Moff Gideon / Ahsoka Tano / The Mandalorian" },
        { n: "MWQ-PJFR", name: "Carrie Fisher / Natalie Portman / Daisy Ridley / Felicity Jones as General Leia Organa / Queen Amidala / Rey / Jyn Erso" },
    ],
  },
  {
    id: "triple-autograph-cards",
    type: "auto",
    title: "TRIPLE AUTOGRAPH CARDS",
    parallels: [
        // Base card is serial-numbered /25 (Cardboard Connection × Beckett agree).
        { id: "base", name: "", print_run: 25, color: "#c8d8f0" },
        { id: "wood", name: "Wood", print_run: 10, color: "#c8946a" },
        { id: "black", name: "Black", print_run: 5, color: "#a8a8b4" },
        { id: "gold", name: "Gold", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "MWT-CPM", name: "Ian McDiarmid / Hayden Christensen / Natalie Portman as Emperor Palpatine / Anakin Skywalker / Padmé Amidala" },
        { n: "MWT-EKC", name: "Erin Kellyman / Emilia Clarke / Alden Ehrenreich as Enfys Nest / Qi'ra / Han Solo" },
        { n: "MWT-MPC", name: "Matthew Wood / Ian McDiarmid / Hayden Christensen as General Grievous / Darth Sidious / Darth Vader" },
    ],
  },
  {
    id: "on-screen-prop-relics-autograph-parallel",
    type: "auto",
    title: "ON SCREEN PROP RELICS AUTOGRAPH PARALLEL",
    parallels: [
        // Serial-numbered /3 (Cardboard Connection × Beckett agree).
        { id: "one-of-one", name: "", print_run: 3, color: "#c8d8f0" },
      ],
    cards: [
        { n: "OSPRA-BR", name: "Riz Ahmed as Bodhi Rook" },
        { n: "OSPRA-CA", name: "Diego Luna as Cassian Andor" },
        { n: "OSPRA-CI", name: "Donnie Yen as Chirrut Îmwe" },
        { n: "OSPRA-GM", name: "Ben Daniels as General Merrick" },
        { n: "OSPRA-JD", name: "Ian McElhinney as Jan Dodonna" },
        { n: "OSPRA-JE", name: "Felicity Jones as Jyn Erso" },
        { n: "OSPRA-K2", name: "Alan Tudyk as K-2SO" },
        { n: "OSPRA-MM", name: "Genevieve O'Reilly as Mon Mothma" },
    ],
  },
  {
    id: "pen-relic-autographs",
    type: "auto",
    title: "PEN RELIC AUTOGRAPHS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "PRA-AB", name: "Ahmed Best as Jar Jar Binks" },
        { n: "PRA-AK", name: "Andrew Kishino as Saw Gerrera" },
        { n: "PRA-AW", name: "Alexander Wraith as Imperial Freighter Pilot" },
        { n: "PRA-CB", name: "Chris Bartlett as Zero" },
        { n: "PRA-CJ", name: "Carey Jones as Krrsantan" },
        { n: "PRA-DA", name: "David Acord as FN-2199" },
        { n: "PRA-DK", name: "Dorian Kingi as Cad Bane" },
        { n: "PRA-DR", name: "Daisy Ridley as Rey" },
        { n: "PRA-GE", name: "Giancarlo Esposito as Moff Gideon" },
        { n: "PRA-GT", name: "Gina Torres as Ketsu Onyo" },
        { n: "PRA-JC", name: "Jim Cummings as Hondo Ohnaka" },
        { n: "PRA-JK", name: "Jaime King as Aurra Sing" },
        { n: "PRA-JL", name: "John Leguizamo as Gor Koresh" },
        { n: "PRA-JS", name: "Jason Spisak as Lux Bonteri" },
        { n: "PRA-KS", name: "Kiran Shah as Nambi Ghima" },
        { n: "PRA-MI", name: "Michonne Bourriague as Aurra Sing" },
        { n: "PRA-MW", name: "Ming-Na Wen as Fennec Shand" },
        { n: "PRA-OA", name: "Omid Abtahi as Dr. Pershing" },
        { n: "PRA-Od", name: "Olivia d'Abo as Luminara Unduli" },
        { n: "PRA-PD", name: "Paul Darnell as Night Wind Assassin" },
        { n: "PRA-RB", name: "Richard Brake as Valin Hess" },
        { n: "PRA-RD", name: "Rosario Dawson as Ahsoka Tano" },
        { n: "PRA-SK", name: "Skyler Bible as Fixer" },
        { n: "PRA-TF", name: "Tait Fletcher as Alpha Trawler" },
        { n: "PRA-TM", name: "Temuera Morrison as Boba Fett" },
    ],
  },
  {
    id: "stamp-cards-autograph-parallel",
    type: "auto",
    title: "STAMP CARDS AUTOGRAPH PARALLEL",
    parallels: [
        // Serial-numbered /3 (Cardboard Connection × Beckett agree).
        { id: "one-of-one", name: "", print_run: 3, color: "#c8d8f0" },
      ],
    cards: [
        { n: "SC-DV", name: "Hayden Christensen as Darth Vader" },
        { n: "SC-HS", name: "Harrison Ford as Han Solo" },
        { n: "SC-KR", name: "Adam Driver as Kylo Ren" },
        { n: "SC-LO", name: "Carrie Fisher as General Leia Organa" },
        { n: "SC-RS", name: "Daisy Ridley as Rey" },
    ],
  },
  {
    id: "manufactured-tools-and-technology-medallion-cards-autograph-parallel",
    type: "auto",
    title: "MANUFACTURED TOOLS AND TECHNOLOGY MEDALLION CARDS AUTOGRAPH PARALLEL",
    parallels: [
        // Serial-numbered /3 (Cardboard Connection × Beckett agree).
        { id: "one-of-one", name: "", print_run: 3, color: "#c8d8f0" },
      ],
    cards: [
        { n: "TTMA-K", name: "Carey Jones as Krrsantan" },
        { n: "TTMA-KR", name: "Adam Driver as Kylo Ren" },
        { n: "TTMA-MG", name: "Giancarlo Esposito as Moff Gideon" },
        { n: "TTMA-P", name: "Ian McDiarmid as Palpatine" },
        { n: "TTMA-Q", name: "Emilia Clarke as Qi'ra" },
        { n: "TTMA-R", name: "Daisy Ridley as Rey" },
        { n: "TTMA-TC", name: "Werner Herzog as The Client" },
    ],
  },
  {
    id: "panoramic-sketch-cards",
    type: "sketch",
    title: "PANORAMIC SKETCH CARDS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "PSK-1", name: "Benjamin Lombert" },
        { n: "PSK-2", name: "Adam Everett Beck" },
        { n: "PSK-3", name: "Basak Kahraman" },
        { n: "PSK-4", name: "Bobby Blakey" },
        { n: "PSK-5", name: "Bradley Hudson" },
        { n: "PSK-6", name: "Brett Farr" },
        { n: "PSK-7", name: "Cory Payne" },
        { n: "PSK-8", name: "Dan Lawler" },
        { n: "PSK-9", name: "Dan Tearle" },
        { n: "PSK-10", name: "Darrin Pepe" },
        { n: "PSK-11", name: "Dean Drummond" },
        { n: "PSK-12", name: "Debjit Kar" },
        { n: "PSK-13", name: "Dwayne Carpenter" },
        { n: "PSK-14", name: "Emre Varlibas" },
        { n: "PSK-15", name: "Francisco Rivera" },
        { n: "PSK-16", name: "Ian Mckesson" },
        { n: "PSK-17", name: "Jamie Richards" },
        { n: "PSK-18", name: "Jamison Murdock" },
        { n: "PSK-19", name: "Jane Rushton" },
        { n: "PSK-20", name: "Jason Sobol" },
        { n: "PSK-21", name: "Jenna McGrath" },
        { n: "PSK-22", name: "Joey Mason" },
        { n: "PSK-23", name: "Jessica Hickman" },
        { n: "PSK-24", name: "John Pleak" },
        { n: "PSK-25", name: "Jonathan Beistline" },
        { n: "PSK-26", name: "Kevin B Cleveland" },
        { n: "PSK-27", name: "Krishna Sharma" },
        { n: "PSK-28", name: "Logan Monette" },
        { n: "PSK-29", name: "Marlo Agunos" },
        { n: "PSK-30", name: "Matt Stewart" },
        { n: "PSK-31", name: "Michael Mastermaker" },
        { n: "PSK-32", name: "Michael Munshaw" },
        { n: "PSK-33", name: "Mike Sealie" },
        { n: "PSK-34", name: "Neil Camera" },
        { n: "PSK-35", name: "Nick Gribbon" },
        { n: "PSK-36", name: "Patricio Carrasco" },
        { n: "PSK-37", name: "Patrick Davis" },
        { n: "PSK-38", name: "Quinton Baker" },
        { n: "PSK-39", name: "Robert Garcia" },
        { n: "PSK-40", name: "Robert Stewart" },
        { n: "PSK-41", name: "CJ Jones" },
        { n: "PSK-42", name: "Shyla Lee" },
        { n: "PSK-43", name: "Veronica Louro" },
        { n: "PSK-44", name: "Rebeca Louro" },
        { n: "PSK-45", name: "Zach Woolsey" },
    ],
  },
  {
    id: "sketch-book-cards",
    type: "sketch",
    title: "SKETCH BOOK CARDS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "SBK-1", name: "Benjamin Lombert" },
        { n: "SBK-2", name: "Andrew Fry" },
        { n: "SBK-3", name: "Dan Lawler" },
        { n: "SBK-4", name: "Bradley Hudson" },
        { n: "SBK-5", name: "Dan Tearle" },
        { n: "SBK-6", name: "Darrin Pepe" },
        { n: "SBK-7", name: "Debjit Kar" },
        { n: "SBK-8", name: "Emre Varlibas" },
        { n: "SBK-9", name: "Francisco Rivera" },
        { n: "SBK-10", name: "Ian Mckesson" },
        { n: "SBK-11", name: "Jamie Richards" },
        { n: "SBK-12", name: "Jamison Murdock" },
        { n: "SBK-13", name: "Jane Rushton" },
        { n: "SBK-14", name: "Jason Sobol" },
        { n: "SBK-15", name: "Jay Manchand" },
        { n: "SBK-16", name: "Jenn DePaola" },
        { n: "SBK-17", name: "Jenn McGrath" },
        { n: "SBK-18", name: "Joey Mason" },
        { n: "SBK-19", name: "John Pleak" },
        { n: "SBK-20", name: "Jonathan Beistline" },
        { n: "SBK-21", name: "Kevin B Cleveland" },
        { n: "SBK-22", name: "Krishna Sharma" },
        { n: "SBK-23", name: "Logan Monette" },
        { n: "SBK-24", name: "Marlo Agunos" },
        { n: "SBK-25", name: "Matt Stewart" },
        { n: "SBK-26", name: "Michael Mastermaker" },
        { n: "SBK-27", name: "Michael Munshaw" },
        { n: "SBK-28", name: "Mike Sealie" },
        { n: "SBK-29", name: "Neil Camera" },
        { n: "SBK-30", name: "Nick Gribbon" },
        { n: "SBK-31", name: "Patrick Davis" },
        { n: "SBK-32", name: "Patricio Carrasco" },
        { n: "SBK-33", name: "Quinton Baker" },
        { n: "SBK-34", name: "Robert Stewart" },
        { n: "SBK-35", name: "Rugved Bhuskute" },
        { n: "SBK-36", name: "Ryan Finley" },
        { n: "SBK-37", name: "Semra Bulut" },
        { n: "SBK-38", name: "CJ Jones" },
        { n: "SBK-39", name: "Veronica Louro" },
        { n: "SBK-40", name: "Rebeca Louro" },
        { n: "SBK-41", name: "Yves Van Berlo" },
        { n: "SBK-42", name: "Zach Woolsey" },
        { n: "SBK-43", name: "Brett Farr" },
        { n: "SBK-44", name: "Dean Drummond" },
        { n: "SBK-45", name: "Cory Payne" },
        { n: "SBK-46", name: "Bobby Blakey" },
        { n: "SBK-47", name: "Basak Kahraman" },
        { n: "SBK-48", name: "Adam Everett Beck" },
    ],
  },
  {
    id: "sketch-cards",
    type: "sketch",
    title: "SKETCH CARDS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "SK-1", name: "Dan Tearle" },
        { n: "SK-2", name: "Benjamin Lombart" },
        { n: "SK-3", name: "Basak Kahraman" },
        { n: "SK-4", name: "Gerry Garcia Jr" },
        { n: "SK-5", name: "Ryan Finley" },
        { n: "SK-6", name: "Oscar Chavez" },
        { n: "SK-7", name: "Jason Montoya" },
        { n: "SK-8", name: "Andrew Fry" },
        { n: "SK-9", name: "Patricio Carrasco" },
        { n: "SK-10", name: "Dan Lawler" },
        { n: "SK-11", name: "Eric Lehtonen" },
        { n: "SK-12", name: "Francisco Rivera" },
        { n: "SK-13", name: "Jamison Murdock" },
        { n: "SK-14", name: "Jenn DePaola" },
        { n: "SK-15", name: "Jessica Hickman" },
        { n: "SK-16", name: "Josh Trout" },
        { n: "SK-17", name: "Kevin Nelson" },
        { n: "SK-18", name: "Krishna Sharma" },
        { n: "SK-19", name: "Kyle Babbitt" },
        { n: "SK-20", name: "Marcia Dye" },
        { n: "SK-21", name: "Patrick Davis" },
        { n: "SK-22", name: "Robert Hendrickson" },
        { n: "SK-23", name: "Veronica Smith" },
        { n: "SK-24", name: "Brent Scotchmer" },
        { n: "SK-25", name: "Bobby Blakey" },
        { n: "SK-26", name: "Neil Camera" },
        { n: "SK-27", name: "Veronica Louro" },
        { n: "SK-28", name: "Zach Woolsey" },
        { n: "SK-29", name: "Tim Shinn" },
        { n: "SK-30", name: "Tom Amici" },
        { n: "SK-31", name: "Michael Munshaw" },
        { n: "SK-32", name: "Angel Aviles" },
        { n: "SK-33", name: "Emre Varlibas" },
        { n: "SK-34", name: "Brett Farr" },
        { n: "SK-35", name: "Chris Thorne" },
        { n: "SK-36", name: "Jonathan Beistline" },
        { n: "SK-37", name: "Matt Stewart" },
        { n: "SK-38", name: "Richard Molinelli" },
        { n: "SK-39", name: "Quinton Baker" },
        { n: "SK-40", name: "John Bruce" },
        { n: "SK-41", name: "Adam Everett Beck" },
        { n: "SK-42", name: "Ian McKesson" },
        { n: "SK-43", name: "Jane Rushton" },
        { n: "SK-44", name: "Jason Sobol" },
        { n: "SK-45", name: "Marlo Agunos" },
        { n: "SK-46", name: "CJ Jones" },
        { n: "SK-47", name: "Michael Mastermaker" },
        { n: "SK-48", name: "Yves Van Berlo" },
        { n: "SK-49", name: "Jay Manchand" },
        { n: "SK-50", name: "Brad Hudson" },
        { n: "SK-51", name: "Cory Payne" },
        { n: "SK-52", name: "Darrin Pepe" },
        { n: "SK-53", name: "Dwayne Carpenter" },
        { n: "SK-54", name: "Gabe Farber" },
        { n: "SK-55", name: "Jamie Richards" },
        { n: "SK-56", name: "Joey Mason" },
        { n: "SK-57", name: "Kevin B Cleveland" },
        { n: "SK-58", name: "Logan Monette" },
        { n: "SK-59", name: "Mike Sealie" },
        { n: "SK-60", name: "Rugved Bhuskute" },
        { n: "SK-61", name: "Semra Bulut" },
        { n: "SK-62", name: "Shyla Lee" },
        { n: "SK-63", name: "Nick Gribbon" },
        { n: "SK-64", name: "Karl Jones" },
        { n: "SK-65", name: "Stephane Leonardi" },
        { n: "SK-66", name: "Rebeca Louro" },
        { n: "SK-67", name: "Dawn Murphy" },
        { n: "SK-68", name: "Julia Mckenzie" },
        { n: "SK-69", name: "Robert Garcia" },
        { n: "SK-70", name: "Rusty Gilligan" },
        { n: "SK-71", name: "Robert Stewart IV" },
        { n: "SK-72", name: "Brandon Klein" },
        { n: "SK-73", name: "Cyrus Sherkat" },
        { n: "SK-74", name: "Jenna McGrath" },
        { n: "SK-75", name: "Ryan Thompson" },
        { n: "SK-76", name: "Neil Anthony Brady" },
        { n: "SK-77", name: "Limuel Pinzon" },
        { n: "SK-78", name: "Alex Mines" },
        { n: "SK-79", name: "Anthony Pietszak" },
        { n: "SK-80", name: "Jason Davies" },
        { n: "SK-81", name: "Luke Seavers" },
        { n: "SK-82", name: "Mike Dalzell" },
        { n: "SK-83", name: "Scott Anthony" },
        { n: "SK-84", name: "Dove McHargue" },
        { n: "SK-85", name: "Eric Medina" },
        { n: "SK-86", name: "Matthew Maldonado" },
        { n: "SK-87", name: "Vincenzo D'lppolito aka Chenduz" },
        { n: "SK-88", name: "Michael Davidson" },
        { n: "SK-89", name: "Chad Thomas" },
        { n: "SK-90", name: "Jackson Ong" },
        { n: "SK-91", name: "Rachel Jane Hetherington" },
        { n: "SK-92", name: "Steve Alce" },
        { n: "SK-93", name: "Candice Dailey" },
        { n: "SK-94", name: "Tim Parsons" },
    ],
  },
  {
    id: "triptych-sketch-cards",
    type: "sketch",
    title: "TRIPTYCH SKETCH CARDS",
    parallels: [
        // TODO (rule 7): if this sub-set's BASE card is numbered, add a
        // blank-name serial slot at the base print run, e.g.
        //   { id: 'base', name: '', print_run: <N>, color: '#c8d8f0' },
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "TSK-1", name: "Benjamin Lombert" },
        { n: "TSK-2", name: "Adam Everett Beck" },
        { n: "TSK-3", name: "Basak Kahraman" },
        { n: "TSK-4", name: "Bobby Blakey" },
        { n: "TSK-5", name: "Bradley Hudson" },
        { n: "TSK-6", name: "Brett Farr" },
        { n: "TSK-7", name: "Cory Payne" },
        { n: "TSK-8", name: "Dan Lawler" },
        { n: "TSK-9", name: "Dan Tearle" },
        { n: "TSK-10", name: "Darrin Pepe" },
        { n: "TSK-11", name: "Dean Drummond" },
        { n: "TSK-12", name: "Debjit Kar" },
        { n: "TSK-13", name: "Dwayne Carpenter" },
        { n: "TSK-14", name: "Emre Varlibas" },
        { n: "TSK-15", name: "Francisco Rivera" },
        { n: "TSK-16", name: "Ian Mckesson" },
        { n: "TSK-17", name: "Jamison Murdock" },
        { n: "TSK-18", name: "Jane Rushton" },
        { n: "TSK-19", name: "Jason Sobol" },
        { n: "TSK-20", name: "Jenna McGrath" },
        { n: "TSK-21", name: "Joey Mason" },
        { n: "TSK-22", name: "John Pleak" },
        { n: "TSK-23", name: "Jonathan Beistline" },
        { n: "TSK-24", name: "Kevin B Cleveland" },
        { n: "TSK-25", name: "Krishna Sharma" },
        { n: "TSK-26", name: "Logan Monette" },
        { n: "TSK-27", name: "Marlo Agunos" },
        { n: "TSK-28", name: "Matt Stewart" },
        { n: "TSK-29", name: "Michael Mastermaker" },
        { n: "TSK-30", name: "Michael Munshaw" },
        { n: "TSK-31", name: "Mike Sealie" },
        { n: "TSK-32", name: "Neil Camera" },
        { n: "TSK-33", name: "Nick Gribbon" },
        { n: "TSK-34", name: "Patricio Carrasco" },
        { n: "TSK-35", name: "Patrick Davis" },
        { n: "TSK-36", name: "Quinton Baker" },
        { n: "TSK-37", name: "Robert Garcia" },
        { n: "TSK-38", name: "Robert Stewart" },
        { n: "TSK-39", name: "Rutvid Vaid" },
        { n: "TSK-40", name: "CJ Jones" },
        { n: "TSK-41", name: "Shyla Lee" },
        { n: "TSK-42", name: "Veronica Louro" },
        { n: "TSK-43", name: "Rebeca Louro" },
        { n: "TSK-44", name: "Yves Van Berlo" },
        { n: "TSK-45", name: "Zach Woolsey" },
        { n: "TSK-46", name: "Neil Anthony Brady" },
    ],
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

// Fallback exports used by Checklist.js for any sub-set with no inline `parallels`.
// Every sub-set above has its own inline array, so these stay empty.
export const PARALLELS = [];
export const AUTO_PARALLELS = [];
export const INSERT_PARALLELS = [];
